import { sendRequest, showErrorMessages } from "../../../functions";
import PhoneInput from "../../formio/components/phone-input";
import { calculateTotalAmount, restyleFormButtons, setBackendValidationRules } from "../../formio/functions";
import { handleAdherentCodeChecking } from "./functions";

$(document).ready(() => {
    $(window).on("load", function () {
        $("html, body").scrollTop(0);
    });


    //get the optional parameters from the url for (exhibitor staff / exhibitor guest)
    const urlParams = new URLSearchParams(window.location.search);
    const exhibitorSlug = urlParams.get('exhibitor');
    const participantTypeSlug = urlParams.get('participantType');


    // Disable submiting if on preview
    if (window.location.pathname.match("preview")) {
        Formio.Components.components.button.prototype.onClick = function (
            event
        ) {
            event.preventDefault();
        };
    }

    Formio.use({
        components: {
            phoneinput: PhoneInput,
        },
    });

    Formio.createForm(document.getElementById("form"), {
        components: JSON.parse(formComponents),
    },
    {
        hooks: {
            customValidation: (submission, next) => {
                if (submission.data.hasOwnProperty('adherent_code')) {

                    if ($('#adhesionAlert').hasClass('alert-danger') || !$('#adhesionAlert').hasClass('alert-success')) {
                        return next([{
                            name: 'adhesionAlert',
                            message: "Veuillez renseigner le code d'adhérent",
                        }]);
                    }

                    try {
                        const response = sendRequest(route('frontend.event.participants.checkAdherentExists', eventSlug), "POST", {"adherent_code": submission.data.adherent_code});

                        if (response.status == 400) {
                            return next([{
                                name: 'adherent_code',
                                message: response.responseJSON.message
                            }]);
                        }

                    } catch(error) {
                        console.error('Error when checking adherent : ', error)
                        alert(unexpectedErrorMessage);
                    }
                }

                return next();
            }
        }
    }).then((form) => {
        restyleFormButtons()
        $("#form").attr('hidden', false);
        let formData = {};

        handleAdherentCodeChecking(form);

        calculateTotalAmount(form);

        // Triggered when they click the submit button.
        form.on("submit", function (submission) {
            $("#inProgressModal").modal("show");
            let validationRules = setBackendValidationRules(form)

            // Constructing form data
            formData = Object.assign(formData, submission.data);
            formData.event_id = eventId;
            formData.form_type = formType;
            formData.rules = JSON.stringify(validationRules);

            formData.exhibitor_slug = exhibitorSlug;
            formData.participant_type_slug = participantTypeSlug;

            sendRequest(formSubmitUrl, "POST", formData)
            .always((response) => {
                setTimeout(() => {
                    $("#inProgressModal").modal("hide");
                }, 300);
            })
        });
    });
});
